<template>
  <div v-if="video_url" class="home-video">
    <div class="embed home-video__player">
      <iframe :src="video_url"
              :title="title"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name:  "HomeVideo",
  props: {
    video_url: {
      type:    String,
      default: '',
    },
    title: {
      type:    String,
      default: 'Video',
    },
  },
}
</script>
